export default __webpack_public_path__ + "static/media/edit-company.b8da232e.webp";